import { render, staticRenderFns } from "./AssociatiList.vue?vue&type=template&id=42476268&"
import script from "./AssociatiList.vue?vue&type=script&lang=ts&"
export * from "./AssociatiList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports